import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import MainImg from "../assets/Images/clause.png";
import TitleImg from "../assets/Images/title.png";
import LineImg from "../assets/Images/line.png";
import ImageTextLayout from "../shared/ImageTextLayout";
import "./ArbitrationClausesPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ArbitrationClausesPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("arbitration_clauses_page_header")}</h1>
          <p className="banner-subtitle">{t("arbitration_clauses_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_arbitration_clauses_page_link1")}</Link>
        <span>{t("breadcrumbs_arbitration_clauses_page_span")}</span>
        <Link>{t("breadcrumbs_arbitration_clauses_page_link2")}</Link>
      </Breadcrumbs>
      <ImageTextLayout
        image={MainImg}
        imageAlt="Arbitration clauses illustration"
        titleIcon={TitleImg}
        title={t("arbitration_clauses_page_h3")}
      >
        <p>{t("arbitration_clauses_page_text1")}</p>
        <p>{t("arbitration_clauses_page_text2")}</p>
        <p>{t("arbitration_clauses_page_text3")}</p>
        <p>{t("arbitration_clauses_page_text4")}</p>
      </ImageTextLayout>
      <div className="clauses-divider">
        <img src={LineImg} alt="Decorative line" className="divider-line" />
      </div>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>

      <Footer />
    </>
  );
};

export default ArbitrationClausesPage;
